export default {
    mounted() {
        this.$listenFor('TICK_MIN', () => {
            this.$gtag.event('pulse', {
                category: this.$options.name,
            })
        })
    },
}
